<template>
  <el-dialog class="pc-dialog pc-dialog__add-notebook-catalog"
    title="添加目录"
    :visible.sync="visible"
    width="40rem"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="closeHandler"
    >
    <div class="path">上级：{{path.join(' / ')}} </div>
    <div class="name">
      <el-input :class="{'pc-is-error':invalid}" v-model="name" :placeholder="placeholder" size="small" @input="validateHandler"
        @keyup.native.enter="okHandler" ref="nameInput"/>
    </div>
    <span slot="footer" class="dialog-footer">
      <span class="pc-color-error" v-show="invalid">{{errorMessage}}</span>
      <el-button type="primary" size="small" @click="okHandler" :disabled="waiting">{{okButtonText}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { isNullOrWhiteSpace } from '@/common/utils'
import { operateError } from '@/common/errors'

export default {
  name: 'AddNotebookCatalogDialog',
  data () {
    return {
      name: '',
      invalid: false,
      waiting: false
    }
  },
  computed: {
    ...mapGetters('dialog', {
      addNotebookCatalogDailogValue: 'addNotebookCatalog'
    }),
    ...mapGetters('workbench/current', {
      notebook: 'notebook',
      catalogPaths: 'catalogPaths'
    }),
    visible: {
      get () {
        return this.addNotebookCatalogDailogValue.visible
      },
      set (visible) {
        this.setAddNotebookCatalogDailogValue({
          visible,
          data: {
            parentCatalogId: ''
          }
        })
      }
    },
    placeholder () {
      return '请输入目录名称'
    },
    okButtonText () {
      let text = '创建目录'
      if (this.waiting) {
        text += ' ...'
      }
      return text
    },
    errorMessage () {
      return '目录名称不能为空'
    },
    path () {
      return this.catalogPaths(this.addNotebookCatalogDailogValue.data.parentCatalogId)
    }
  },
  methods: {
    ...mapMutations('dialog', {
      setAddNotebookCatalogDailogValue: 'SET_ADD_NOTEBOOK_CATALOG'
    }),
    ...mapActions('workbench/current', {
      addNotebookCatalog: 'addNotebookCatalog'
    }),
    closeHandler () {
      this.name = ''
      this.invalid = false
      this.waiting = false
    },
    validateHandler () {
      if (isNullOrWhiteSpace(this.name)) {
        this.invalid = true
      } else {
        this.invalid = false
      }
    },
    async okHandler () {
      this.validateHandler()
      if (this.invalid) {
        return
      }
      try {
        this.waiting = true
        await this.addNotebookCatalog({
          parentCatalogId: this.addNotebookCatalogDailogValue.data.parentCatalogId,
          name: this.name
        })
        this.setAddNotebookCatalogDailogValue({
          visible: false,
          data: {
            parentCatalogId: ''
          }
        })
      } catch (e) {
        console.dir(e)
        operateError(e, '添加目录')
      } finally {
        this.waiting = false
      }
    }
  },
  watch: {
    visible (newValue) {
      if (newValue) {
        this.$nextTick(() => {
          this.$refs.nameInput.focus()
        })
      }
    }
  }
}
</script>

<style lang="scss">
.pc-dialog__add-notebook-catalog {
  .path {
    margin-bottom: 1rem;
  }
  .pc-color-error {
    margin-right: 1rem;
  }

  .el-input__inner {
    font-size: 1.2rem;
  }
}
</style>
